<template>
  <ld-json :json="jsonld" />
</template>

<script setup lang="ts">
import { LdJson } from 'atoms';
import { computed } from 'vue';

import { useCatalog } from '@/composables/catalog';
import { useCatalogTextList } from '@/composables/catalogTextList';
import { useFischer } from '@/composables/fischerPlugin';

defineOptions({ name: 'ProductFamilySchemaFi' });

const props = withDefaults(
  defineProps<{
    variants?: any[] | null;
    categoryData?: Record<string, any> | null;
  }>(),
  {
    variants: null,
    categoryData: null,
  },
);

const fischer = useFischer();
const { getFamilyThumbnails } = useCatalog();
const { textListValue } = useCatalogTextList();

const jsonld = computed(() => {
  if (props.categoryData && textListValue(props.categoryData.TextList, 'BEZEICHNUNG')) {
    const base = `${fischer.hostUrlBase()}${fischer.pages.products().url}`;
    let variantsObj: any[] = [];

    if (props.variants?.length) {
      variantsObj = props.variants.map((variant) => {
        const { Name, Slug, ImageURL, ID } = variant.variantValuesObject[0];
        if (Name) {
          return {
            '@type': 'Product',
            name: Name,
            url: `${base}${Slug}`,
            productID: ID,
            image: ImageURL,
          };
        }
      });
    }

    return JSON.stringify({
      '@context': 'https://schema.org/',
      '@type': 'ProductGroup',
      '@id': `${base}${props.categoryData.Slug}`,
      brand: fischer.brandName(),
      name: textListValue(props.categoryData.TextList, 'BEZEICHNUNG'),
      description: props.categoryData.description,
      image: getFamilyThumbnails(props.categoryData)?.map((el) => el.Url)?.[0],
      hasVariant: variantsObj,
    });
  }

  return null;
});
</script>
